'use client';


import type { ReactNode } from 'react';
import { MusicPlayer } from '@/components/music/music-player';

import { AppAuthProvider } from '@/components/auth/auth-provider';
import { usePathname } from 'next/navigation';
import { CartProvider, PreviewCartProvider } from '@/components/cart/cart-context';
import { HomepageSettingsProvider } from '@/hooks/use-homepage-settings';
import { Toaster } from '@/components/ui/toaster';
import { FirebaseAnalyticsBootstrap } from '@/components/providers/firebase-analytics-bootstrap';
import type { HomepageSettingsDoc } from '@/types/platform';
import { CookieConsentBanner } from '@/components/privacy/cookie-consent-banner';

export default function ClientProviders({
  children,
  initialHomepageSettings,
}: {
  children: ReactNode;
  initialHomepageSettings: HomepageSettingsDoc | null;
}) {
  const pathname = usePathname();
  // Preview tabs must not bootstrap auth writes, analytics, music or cart storage.
  if (pathname === '/catalog-preview' || pathname?.startsWith('/catalog-preview/')) return (
    <HomepageSettingsProvider initialSettings={initialHomepageSettings}>
      <PreviewCartProvider>{children}</PreviewCartProvider>
    </HomepageSettingsProvider>
  );
  return (
    <AppAuthProvider>
      <HomepageSettingsProvider initialSettings={initialHomepageSettings}>
        <CartProvider>
          {children}
          <FirebaseAnalyticsBootstrap />
          <CookieConsentBanner />
          <Toaster />
          <MusicPlayer />
        </CartProvider>
      </HomepageSettingsProvider>
    </AppAuthProvider>
  );
}
